import React, { useEffect, useState } from "react";
import styled from "styled-components";
import { Icon } from "../../atoms";
import { ActiveCoinService } from "../../../utils/RxServices/SharedService";
import { useLocation } from "react-router-dom";

const CrptoMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  width: 115px;
  position: relative;
  justify-content: space-between;
`;
interface ICryptoChoose {
  onClick: () => void;
}
export const CryptoHeaderMenu: React.FC<ICryptoChoose> = ({ onClick }) => {
  const [coin, setCoin] = useState<string>("gold_bullion_1");
  const location = useLocation();

  useEffect(() => {
    const urlSymbol =
      new URLSearchParams(location.search).get("symbol") || "gold_bullion_1";
    setCoin(urlSymbol);
    const activeSubscription = ActiveCoinService.onCoinChanged.subscribe(
      (coin) => {
        setCoin(coin);
      }
    );
    return () => {
      activeSubscription.unsubscribe();
    };
  }, [location.search]);
  return (
    <CrptoMenuWrapper onClick={onClick}>
      {/*<CryptoIconWithSymbol*/}
      {/*  iconName={coin}*/}
      {/*  symbolName={coin}*/}
      {/*  unitName={"IRT"}*/}
      {/*  isMobile={true}*/}
      {/*/>*/}
      <Icon name="arrowdown" width="12px" height="12px" />
    </CrptoMenuWrapper>
  );
};
